import { createContext, useContext } from "react";

type TaskClaimsSheetContextType = {
  shouldDisableClaims: boolean;
};

const TaskClaimsSheetContext = createContext<TaskClaimsSheetContextType>({
  shouldDisableClaims: false,
});

export const TaskClaimsSheetProvider = ({
  shouldDisableClaims = false,
  children,
}: {
  shouldDisableClaims: boolean;
  children: React.ReactNode;
}): React.JSX.Element => {
  return (
    <TaskClaimsSheetContext.Provider value={{ shouldDisableClaims }}>
      {children}
    </TaskClaimsSheetContext.Provider>
  );
};

export const useTaskClaimsSheetContext = (): TaskClaimsSheetContextType => {
  return useContext(TaskClaimsSheetContext);
};
